import { NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { OrderType, PaymentType, PaymentTypeIconPipe, PaymentTypeLabelPipe } from '@us/web/shared/data-access';
import { TuiGroupModule, TuiSvgModule } from '@taiga-ui/core';
import { TuiAvatarModule, TuiRadioBlockModule } from '@taiga-ui/kit';
import { TuiDestroyService } from '@taiga-ui/cdk';
import { filter, takeUntil, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectBankTransferInformation } from '@us/web/shop/data-access';

@Component({
    selector: 'us-payment-type-options',
    standalone: true,
    imports: [
        TranslocoModule,
        PaymentTypeLabelPipe,
        PaymentTypeIconPipe,
        FormsModule,
        NgForOf,
        TuiSvgModule,
        TuiGroupModule,
        TuiRadioBlockModule,
        ReactiveFormsModule,
        TuiAvatarModule,
        NgIf
    ],
    providers: [TuiDestroyService],
    templateUrl: './payment-type-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentTypeOptionsComponent implements OnInit {
    @Input() options: PaymentType[] = [];
    @Input() orderType!: OrderType;
    @Input() value: PaymentType | null = null;
    @Output() valueChange: EventEmitter<PaymentType> = new EventEmitter<PaymentType>();

    private readonly store = inject(Store);
    readonly bankTransferInformation = this.store.selectSignal(selectBankTransferInformation);

    private readonly destroy$ = inject(TuiDestroyService, { self: true });

    readonly PaymentType = PaymentType;

    readonly paymentTypeCtrl = new FormControl<PaymentType | null>(null);

    ngOnInit() {
        this.paymentTypeCtrl.patchValue(this.value);

        this.paymentTypeCtrl.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                filter(value => value !== null),
                tap(value => this.valueChange.emit(value as PaymentType))
            )
            .subscribe();
    }

    onSelect() {
        if (this.value !== null) {
            this.valueChange.emit(this.value);
        }
    }
}
